import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {useCachedTable} from 'src/hooks/common-data-service/cached-table';
import {getUsersSavedSearches} from 'src/openapi/admin/apis/UserSearchApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    userSearchResultSavedSearchesActions,
    userSearchResultSavedSearchesDataSelector,
    userSearchResultSavedSearchesResultSelector,
} from '../slices/user-search-result-saved-searches.slice';
import {userSearchResultStateSelector} from '../slices/user-search-result-state.slice';

import type {UserSearchResultCacheKeys} from '../typedef';
import type {UserSavedSearch} from 'src/openapi/admin/models/UserSavedSearch';


type Props = {
    userIds: number[],
    totalCount: number,
};

export const useGetUserSearchResultSavedSearches = ({userIds, totalCount}: Props) => {
    const apiDispatch = useAppDispatch();
    const dispatch = useDispatch();

    const getAction = useCallback(() => apiDispatch(getUsersSavedSearches({
        requestBody: userIds,
    })), [userIds, apiDispatch]);

    const setLoadedData = useCallback((
        response: Record<string, UserSavedSearch>,
        dataCacheKeys: UserSearchResultCacheKeys,
    ) => {
        dispatch(userSearchResultSavedSearchesActions.onSuccess(({
            cacheKeys: dataCacheKeys,
            totalCount,
            data: response,
        })));
    }, [totalCount, dispatch]);

    return useCachedTable({
        dataSelector: userSearchResultSavedSearchesDataSelector,
        stateSelector: userSearchResultStateSelector,
        resultSelector: userSearchResultSavedSearchesResultSelector,
        actions: userSearchResultSavedSearchesActions,
        getAction,
        onSuccessLoad: setLoadedData,
        shouldClearOnUnmount: false,
    });
};
